import React from 'react';
import { useParams } from 'react-router-dom';
import { Tabs } from '@mantine/core';

import { menuListAdminStaf, role } from "../../utils/globalVariables";

import LayoutAppShell from "../../layout/LayoutAppShell";
import HeaderNav from "../../layout/HeaderNav";
import WrapperHeaderTab from "../../layout/WrapperHeaderTab";
import WrapperTab from "../../layout/WrapperTab";

import CustomerIndex from "../../pagesSub/msCustomer/CustomerIndex";
import BarangKategoriIndex from "../../pagesSub/msBarangKategori/BarangKategoriIndex";
import BarangFormCekIndex from "../../pagesSub/msBarangFormCek/BarangFormCekIndex";

import DiscountMasterIndex from "../../pagesSub/msDiscount/DiscountMasterIndex";
import DiscountSpecialIndex from "../../pagesSub/msDiscountSpecial/DiscountSpecialIndex";

import StockCategorySubIndex from "../../pagesSub/msStockCategorySub/StockCategorySubIndex";
import StockCategoryIndex from "../../pagesSub/msStockCategory/StockCategoryIndex";
import StockItemIndex from "../../pagesSub/msStockItem/StockItemIndex";
import StokItemRusakIndex from "../../pagesSub/msStockItemRusak/StokItemRusakIndex";

import SupplierIndex from "../../pagesSub/msSupplier/SupplierIndex";
import CustomerGroupIndex from "../../pagesSub/msCustomerGroup/CustomerGroupIndex";

const MasterAS = () => {

    const { subMenu, tab } = useParams();
    const menu = menuListAdminStaf.master.slug;
    const roleUser = role.admin;
    const slugLink = roleUser.subLevel.admin_staf.slugLink;

    // info : struktur menuList nya harus sama !
    const menuListUserForDirectNotaStep = menuListAdminStaf;

    return (
        <LayoutAppShell
            stateMenuList={menuListAdminStaf}
            stateMenu={menu}
            stateLocalStorageIdleTimerName={roleUser.localStorageIdleTimeName}
        >
            {menuListAdminStaf.master.subMenu.two.flag === subMenu &&
                <React.Fragment>
                    <WrapperHeaderTab>
                        <HeaderNav
                            stateMenuList={menuListAdminStaf}
                            stateMenu={menu}
                            stateSubMenu={subMenu}
                        />
                    </WrapperHeaderTab>

                    <CustomerIndex
                        stateMenuList={menuListUserForDirectNotaStep}
                    />
                </React.Fragment>
            }

            {menuListAdminStaf.master.subMenu.customerGroup.flag === subMenu &&
                <React.Fragment>
                    <WrapperHeaderTab>
                        <HeaderNav
                            stateMenuList={menuListAdminStaf}
                            stateMenu={menu}
                            stateSubMenu={subMenu}
                        />
                    </WrapperHeaderTab>

                    <CustomerGroupIndex
                        stateMenuList={menuListUserForDirectNotaStep}
                    />
                </React.Fragment>
            }

            {menuListAdminStaf.master.subMenu.brgKtgr.flag === subMenu &&
                <React.Fragment>
                    <WrapperHeaderTab>
                        <HeaderNav
                            stateMenuList={menuListAdminStaf}
                            stateMenu={menu}
                            stateSubMenu={subMenu}
                        />
                    </WrapperHeaderTab>

                    <BarangKategoriIndex />
                </React.Fragment>
            }

            {menuListAdminStaf.master.subMenu.formCekBrg.flag === subMenu &&
                <React.Fragment>
                    <WrapperHeaderTab>
                        <HeaderNav
                            stateMenuList={menuListAdminStaf}
                            stateMenu={menu}
                            stateSubMenu={subMenu}
                        />
                    </WrapperHeaderTab>

                    <BarangFormCekIndex />
                </React.Fragment>
            }

            {menuListAdminStaf.master.subMenu.stock.flag === subMenu &&
                <React.Fragment>
                    <WrapperHeaderTab>
                        <HeaderNav
                            stateMenuList={menuListAdminStaf}
                            stateMenu={menu}
                            stateSubMenu={subMenu}
                        />

                        <WrapperTab
                            stateNavigate={`/${slugLink}/${menu}/${subMenu}/`}
                            stateKeepMounted={false}
                        >
                            <Tabs.Tab value={menuListAdminStaf.master.subMenu.stock.tabs.two.flag}>
                                {menuListAdminStaf.master.subMenu.stock.tabs.two.name}
                            </Tabs.Tab>

                            <Tabs.Tab value={menuListAdminStaf.master.subMenu.stock.tabs.three.flag}>
                                {menuListAdminStaf.master.subMenu.stock.tabs.three.name}
                            </Tabs.Tab>

                            <Tabs.Tab value={menuListAdminStaf.master.subMenu.stock.tabs.one.flag}>
                                {menuListAdminStaf.master.subMenu.stock.tabs.one.name}
                            </Tabs.Tab>

                            <Tabs.Tab value={menuListAdminStaf.master.subMenu.stock.tabs.four.flag}>
                                {menuListAdminStaf.master.subMenu.stock.tabs.four.name}
                            </Tabs.Tab>
                        </WrapperTab>
                    </WrapperHeaderTab>

                    <Tabs value={tab} keepMounted={false}>
                        <Tabs.Panel value={menuListAdminStaf.master.subMenu.stock.tabs.one.flag}>
                            <StockItemIndex />
                        </Tabs.Panel>

                        <Tabs.Panel value={menuListAdminStaf.master.subMenu.stock.tabs.two.flag}>
                            <StockCategoryIndex />
                        </Tabs.Panel>

                        <Tabs.Panel value={menuListAdminStaf.master.subMenu.stock.tabs.three.flag}>
                            <StockCategorySubIndex />
                        </Tabs.Panel>

                        <Tabs.Panel value={menuListAdminStaf.master.subMenu.stock.tabs.four.flag}>
                            <StokItemRusakIndex />
                        </Tabs.Panel>
                    </Tabs>
                </React.Fragment>
            }

            {menuListAdminStaf.master.subMenu.supplier.flag === subMenu &&
                <React.Fragment>
                    <WrapperHeaderTab>
                        <HeaderNav
                            stateMenuList={menuListAdminStaf}
                            stateMenu={menu}
                            stateSubMenu={subMenu}
                        />
                    </WrapperHeaderTab>

                    <SupplierIndex />
                </React.Fragment>
            }

            {menuListAdminStaf.master.subMenu.discount.flag === subMenu &&
                <React.Fragment>
                    <WrapperHeaderTab>
                        <HeaderNav
                            stateMenuList={menuListAdminStaf}
                            stateMenu={menu}
                            stateSubMenu={subMenu}
                        />

                        <WrapperTab
                            stateNavigate={`/${slugLink}/${menu}/${subMenu}/`}
                            stateKeepMounted={false}
                        >
                            <Tabs.Tab value={menuListAdminStaf.master.subMenu.discount.tabs.one.flag}>
                                {menuListAdminStaf.master.subMenu.discount.tabs.one.name}
                            </Tabs.Tab>

                            <Tabs.Tab value={menuListAdminStaf.master.subMenu.discount.tabs.two.flag}>
                                {menuListAdminStaf.master.subMenu.discount.tabs.two.name}
                            </Tabs.Tab>
                        </WrapperTab>
                    </WrapperHeaderTab>

                    <Tabs value={tab} keepMounted={false}>
                        <Tabs.Panel value={menuListAdminStaf.master.subMenu.discount.tabs.one.flag}>
                            <DiscountMasterIndex />
                        </Tabs.Panel>

                        <Tabs.Panel value={menuListAdminStaf.master.subMenu.discount.tabs.two.flag}>
                            <DiscountSpecialIndex />
                        </Tabs.Panel>
                    </Tabs>
                </React.Fragment>
            }
        </LayoutAppShell>
    )
}

export default MasterAS;